import React from 'react';
import { cn } from '../../design-system/cn';
import { consoleRadii, consoleTypography } from '../../design-system/tokens';
import { ModalHeader } from './Modal';

const ICON_VARIANTS = {
  brand: 'bg-[#8cff4a]/10 border-[#8cff4a]/30 text-[#8cff4a]',
  wallet: 'bg-[#33d6ff]/10 border-[#33d6ff]/30 text-[#33d6ff]',
  live: 'bg-[#ff6b2c]/10 border-[#ff6b2c]/30 text-[#ff6b2c]',
  friends: 'bg-[#8cff4a]/10 border-[#8cff4a]/25 text-[#8cff4a]',
  neutral: 'bg-[#0d1118] border-white/10 text-[#9da7b6]',
};

/** Icon + title header used across Lockbox modals. */
export default function LockboxModalHeader({
  emoji,
  iconClassName,
  iconVariant = 'brand',
  title,
  subtitle,
  onClose,
  compact = false,
}) {
  const iconStyles = iconClassName || ICON_VARIANTS[iconVariant] || ICON_VARIANTS.brand;

  return (
    <ModalHeader
      onClose={onClose}
      className={compact ? 'p-4' : undefined}
      title={(
        <div className="flex items-center gap-2.5 min-w-0">
          {emoji && (
            <div
              className={cn(
                'border flex items-center justify-center shrink-0',
                consoleRadii.md,
                compact ? 'w-8 h-8 text-base' : 'w-10 h-10 text-xl',
                iconStyles,
              )}
            >
              {emoji}
            </div>
          )}
          <div className="min-w-0">
            <h2 className={cn(
              consoleTypography.section,
              'truncate',
              compact ? 'text-base' : 'text-lg',
            )}
            >
              {title}
            </h2>
            {subtitle && (
              <p className={cn(consoleTypography.meta, 'truncate mt-0.5')}>
                {subtitle}
              </p>
            )}
          </div>
        </div>
      )}
    />
  );
}
